import type { FC } from "react";

import { LowCreditsBanner } from "app/pages/sales-intelligence/modules/quota/components/LowCreditsBanner/LowCreditsBanner";
import { useLowCreditsBannerVisibility } from "app/pages/sales-intelligence/modules/quota/hooks/useLowCreditsBannerVisibility";
import { useLowQuotaBannerManagement } from "app/pages/sales-intelligence/modules/quota/hooks/useLowQuotaBannerManagement";
import type { LowQuotaBannerDestinationType } from "app/pages/sales-intelligence/modules/quota/types";

import { LowCreditsBannerWrapper, StyledSelectionDropdownQuotaFooterContainer } from "./styles";

interface ISelectionDropdownQuotaFooterProps {
    totalQuota: number;
    remainingQuota: number;
    pricePerRecord?: number;
    maxOptionValue?: number;
    destinationType?: LowQuotaBannerDestinationType;
}

export const SelectionDropdownQuotaFooter: FC<ISelectionDropdownQuotaFooterProps> = ({
    totalQuota,
    remainingQuota,
    pricePerRecord,
    maxOptionValue,
    destinationType,
}) => {
    const { lowCreditsBannerConfigs } = useLowQuotaBannerManagement(destinationType);

    const showBanner = useLowCreditsBannerVisibility({
        totalQuota,
        remainingQuota,
        pricePerRecord,
        maxOptionValue,
    });

    return (
        <StyledSelectionDropdownQuotaFooterContainer>
            {showBanner ? (
                <LowCreditsBannerWrapper>
                    <LowCreditsBanner
                        {...lowCreditsBannerConfigs}
                        isStacked
                    />
                </LowCreditsBannerWrapper>
            ) : null}
        </StyledSelectionDropdownQuotaFooterContainer>
    );
};
